'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.props.error) {
        theme.labelColor = theme.errorLabelColor;
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            font: theme.tsNormal + '/' + theme.tlNormal + ' "' + theme.fontFamily + '"',
            userSelect: 'none',
            display: 'inline-block',
            // overflow: 'hidden',
            verticalAlign: 'bottom',
            width: theme.width,
            minWidth: theme.minWidth
        },
        label: {
            textAlign: 'left',
            fontSize: theme.labelFontSize,
            lineHeight: theme.labelLineHeight,
            color: theme.labelColor
        },
        input: {
            // padding: `${theme.gutter}px 0`,
        },
        wrapper: {
            border: '1px solid ' + theme.borderColor,
            background: theme.background,
            borderRadius: theme.borderRadius,
            position: 'relative',
            // overflow: 'hidden',
            display: 'flex'
        },
        mask: {
            position: 'absolute',
            transform: 'translateX(0)',
            left: 0,
            zIndex: 2,
            top: 0,
            background: theme.maskBackground,
            borderRadius: theme.borderRadius,
            padding: theme.padding,
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            transitionDuration: theme.transitionDuration,
            transitionTimingFunction: theme.transitionFunction,
            transitionProperty: 'transform, width, background-color, color, box-shadow',
            boxSizing: 'border-box',
            boxShadow: theme.maskBoxShadow,
            color: theme.maskColor,
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            flex: 1,
            justifyContent: 'center',

            '&:hover': {
                background: theme.hoverMaskBackground,
                color: theme.hoverMaskColor,
                boxShadow: theme.hoverMaskBoxShadow
            },

            '&:active': {
                background: theme.hoverMaskBackground,
                color: theme.hoverMaskColor,
                boxShadow: theme.hoverMaskBoxShadow
            }
        },
        field: {
            display: 'none'
        },
        fieldLabel: {
            position: 'relative',
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            color: theme.color,
            background: 'transparent',
            boxSizing: 'border-box',
            padding: theme.padding,
            borderRadius: theme.borderRadius,
            transitionDuration: theme.transitionDuration,
            transitionTimingFunction: theme.transitionFunction,
            transitionProperty: 'background-color, color, box-shadow',
            display: 'inline-flex',
            flex: 1,
            justifyContent: 'center',
            whiteSpace: 'nowrap',
            zIndex: 1,
            boxShadow: theme.boxShadow,

            '& >*': {
                display: 'inline-block'
            },

            '&:hover': {
                color: theme.hoverColor,
                background: theme.hoverBackground,
                cursor: 'pointer',
                boxShadow: theme.hoverBoxShadow
            },

            '&:active': {
                background: theme.activeBackground,
                color: theme.activeColor,
                boxShadow: theme.activeBoxShadow
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        fieldLabel: (0, _aphroditeJss.css)(styleList.fieldLabel),
        field: (0, _aphroditeJss.css)(styleList.field),
        mask: (0, _aphroditeJss.css)(styleList.mask),
        wrapper: (0, _aphroditeJss.css)(styleList.wrapper),
        label: (0, _aphroditeJss.css)(styleList.label),
        input: (0, _aphroditeJss.css)(styleList.input)
    };
};

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _aphroditeJss = require('aphrodite-jss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    var primary = (0, _color2.default)(theme.elAccent),
        hoverColor = void 0;

    hoverColor = primary.rotate(2);
    hoverColor = (0, _color2.default)(hoverColor).saturate(0.3);
    hoverColor = (0, _color2.default)(hoverColor).darken(0.2);
    hoverColor = hoverColor.rgb().string();

    return {
        color: theme.tInactive,
        fontSize: theme.tsNormal,
        lineHeight: 1.5,
        borderColor: theme.elDivider,
        background: theme.elPrimary,
        padding: '4px ' + theme.gutter * 2 + 'px',
        borderRadius: '27px',
        boxShadow: 'none',

        hoverColor: theme.tFilled,
        hoverBackground: theme.elPrimary,
        hoverBoxShadow: 'none',

        activeColor: theme.tActive,
        activeBackground: theme.elPrimary,
        activeBoxShadow: 'none',

        labelColor: theme.tLabel,
        labelFontSize: theme.tsXSmall,
        labelLineHeight: theme.tlXSmall,

        maskColor: theme.tInversion,
        maskBackground: theme.elAccent,
        maskBoxShadow: '0 2px 4px 0 ' + theme.elShadowMain,

        hoverMaskColor: theme.tInversion,
        hoverMaskBackground: hoverColor,
        hoverMaskBoxShadow: '0 2px 4px 0 ' + theme.elShadowMain,

        errorLabelColor: theme.tError,

        width: 'auto',
        minWidth: 'auto'
    };
};